import { INiche } from "@/common/services/types";
import { useFollowingNiche } from "@/common/hooks/useFollowingNiche";

import { Columnizer } from "@/components/blocks/Columnizer";
import { NichePreview } from "@/components/niches/NichePreview";
import { NicheBlockPlaceholder } from "@/components/UI/Skeleton/Skeleton";
import { Loader } from "@/components/UI/Loader";
import { InfiniteScroll } from "@/components/utils/InfiniteScroll";

import "./NicheBrowser.scss";

const PLACEHOLDERS_WITH_PREVIEW = 50;
const PLACEHOLDERS_WITHOUT_PREVIEW = 30;
const COLUMN_SIZE = 500;

interface IProps {
  niches: INiche[];
  myNiche?: boolean;
  isLoading: boolean;
  withPreview?: boolean;
  fetchMore?: () => void;
  hasMore?: boolean;
}

export const NicheBrowser = ({ niches, myNiche, isLoading, withPreview, fetchMore = () => {}, hasMore = false }: IProps) => {
  const { onFollow, isFollowing } = useFollowingNiche();

  const renderNiches = () => {
    if (!niches.length && isLoading) {
      return new Array(!withPreview ? PLACEHOLDERS_WITH_PREVIEW : PLACEHOLDERS_WITHOUT_PREVIEW)
        .fill("")
        .map((___, index) => <NicheBlockPlaceholder key={index} />);
    }

    if (!niches.length && !isLoading) {
      return <p>No niches to show on this page.</p>;
    }

    return niches.map(niche => (
      <NichePreview
        key={niche.id}
        niche={niche}
        following={isFollowing(niche.id)}
        onFollow={onFollow}
        isLink={myNiche}
        withPreview={withPreview}
      />
    ));
  };

  return (
    <div className="niches nicheBrowser">
      <InfiniteScroll
        fetchMore={fetchMore}
        hasMore={hasMore}
      >
        <Columnizer sizes={[COLUMN_SIZE]}>
          {renderNiches()}
        </Columnizer>
        { isLoading && niches.length && <Loader /> }
      </InfiniteScroll>
    </div>
  );
};
